<script lang="ts">
	const TIMEOUT_MS = 3000;

	let message: string = '';

	export const open = (newMessage: string) => {
		const notification = document.getElementById('action-notification');
		if (!notification) {
			return;
		}
		message = newMessage;
		notification.style.visibility = 'visible';
		clearTimeout(lastTimeout);
		lastTimeout = setTimeout(() => {
			notification.style.visibility = 'hidden';
		}, TIMEOUT_MS);
	};

	export const close = () => {
		const notification = document.getElementById('action-notification');
		if (!notification) {
			return;
		}
		notification.style.visibility = 'hidden';
	};

	let lastTimeout: NodeJS.Timeout | undefined = undefined;
</script>

<div
	id="action-notification"
	class="fixed bottom-4 left-1/2 h-10 w-fit px-4 flex flex-row justify-center items-center text-xs rounded border shadow-lg
	text-zinc-900 bg-primary-50 border-primary-200
	dark:text-zinc-200 dark:bg-zinc-800 dark:border-zinc-700"
	style="transform: translateX(-50%)"
>
	{message}
</div>

<style>
	#action-notification {
		visibility: hidden;
	}
</style>
